import React from "react";

import { useAppStore } from "@store/appStateStore";
import { updateAttendance, fetchAttendances } from "@services/api";

import AgGridTable from "@components/shared/AgGridTable";
import { ActionCellRenderer } from "@components/shared/actionColumn";

import { getColumnDefs } from "./columnDefs";

const AttendancesTable: React.FC<{
  hasAmount?: boolean;
  hasIsPaid?: boolean;
}> = ({ hasAmount, hasIsPaid }) => {
  const { attendances, directions, setAttendances } = useAppStore();

  const handleCellValueChanged = async (params: any) => {
    const { data, colDef, newValue, oldValue } = params;
    if (newValue === oldValue) return;

    const field = colDef.field;
    const updates: any = {};
    updates[field] = newValue;

    // Для поля is_paid преобразуем булево значение в 1/0
    if (field === "is_paid") {
      updates[field] = newValue ? 1 : 0;
    }
    if (field === "direction_id") {
      updates[field] = directions.find((d) => d.name === newValue)?.id || null;
    }
    try {
      await updateAttendance(data.id, updates);

      const updatedAttendances = await fetchAttendances();
      setAttendances(updatedAttendances);
    } catch (error) {
      console.error("Ошибка:", error);
      alert("Ошибка обновления посещения");
    }
  };

  const handleDeleteSuccess = async () => {
    try {
      const attendances = await fetchAttendances();
      setAttendances(attendances);
    } catch (error) {
      console.error("Ошибка загрузки посещений после удаления:", error);
      alert("Ошибка обновления списка посещений");
    }
  };

  const columnDefs = getColumnDefs(
    hasAmount ? true : false,
    hasIsPaid ? true : false,
    handleCellValueChanged,
    handleDeleteSuccess,
    directions,
  );

  return (
    <AgGridTable
      rowData={attendances}
      columnDefs={columnDefs}
      title="Посещения"
      components={{ ActionCellRenderer: ActionCellRenderer }}
      height={550}
    />
  );
};

export default AttendancesTable;
